<header>
  <div class="header-container">
    <div class="hamburger" (click)="toggleSidebar()">
      <i *ngIf="!sidebarOpen" class="pi pi-bars"></i>
      <i *ngIf="sidebarOpen" class="pi pi-times"></i>
    </div>

    <ng-container *ngIf="properties && properties.length > 0">
      <select [(ngModel)]="selectedPropertyId" (change)="switchProperty($event)">
        <option value="" disabled selected>Select Property</option>
        <option *ngFor="let p of properties" [value]="p._id">
          {{ p.name }}
        </option>
      </select>
      <button *ngIf="isImpersonating" (click)="exit()">Exit Impersonation</button>
    </ng-container>


    <div class="d-flex align-items-center">
      <div class="notifications" *ngIf="!isTenant" (click)="toggleNotifications()">
        <span class="pi pi-bell"></span>
        <span *ngIf="unreadCount > 0" class="notification-badge">
          {{ unreadCount > 9 ? '9+' : unreadCount }}
        </span>
      </div>
      <div class="user" (click)="toggleUserDetails()">
        <div class="user-img">
          <img src="./assets/images/user_avatar.jpg" alt="User Image" />
        </div>
        <i class="pi pi-angle-down"></i>
      </div>
    </div>
  </div>

  <div class="notifications-popup" *ngIf="notificationsVisible && !isTenant">
    <div class="popup-content">
      <div class="d-flex w-100 justify-content-between gap-2 align-items-center">
        <h5>Notifications ({{unreadCount}})</h5>
        <div class="d-flex align-items-center gap-2">
          <p-button pTooltip="Get Latest Notifications..." tooltipPosition="top" pbutton class="icon-secondary-btn"
            (click)="fetchNotifications()" icon="pi pi-refresh"></p-button>
          <p-button pbutton class="icon-secondary-btn" (click)="toggleNotifications()" icon="pi pi-times"></p-button>
        </div>
      </div>
      <ul class="notifications-list">
        <li *ngFor="let notification of notifications" [class.unread]="!notification.read">
          <div class="notification-item">
            <div style="font-size: 12px;">
              <strong>Unit:</strong> {{ notification.plan_name }}
            </div>
            <div style="font-size: 12px;">
              <strong>Date:</strong> {{ notification.date }}
            </div>
            <div style="font-size: 12px;">
              <strong>Time:</strong> {{ notification.time }} ({{ notification.client_formatted_time_zone }})
            </div>
            <div class="mt-2" style="font-size: 12px;">
              <!-- Link opens in a new tab -->
              <a [href]="baseUrl.endsWith('/') 
                    ? baseUrl + 'users/mark-complete/' + notification._id 
                    : baseUrl + '/users/mark-complete/' + notification._id" target="_blank" rel="noopener noreferrer"
                style="color: blue; text-decoration: underline;">
                Accept Invite
              </a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>


  <div class="user-details-popup" *ngIf="userDetailsVisible">
    <div class="popup-content" *ngIf="userInfo">
      <div class="d-flex w-100 justify-content-end">
        <button pbutton class="close-btn" (click)="closeUserDetails()"><i class="pi pi-times"></i></button>
      </div>
      <div class="d-flex flex-column">
        <small class="user-welcome">Welcome, <strong>{{ userInfo?.fullName }}</strong></small>
        <small>Email: {{ userInfo?.email }}</small>
      </div>
      <p-button pbutton class="primary-btn" styleClass="w-100 mt-2" label="Edit Profile" (click)="showEditProfile()" />
      <p-button pbutton class="primary-btn" styleClass="w-100 mt-2" label="Logout" (click)="logout()" />
    </div>
  </div>

  <p-dialog *ngIf="editProfileVisible" header="Edit Profile" [modal]="true"
    [(visible)]="editProfileVisible" position="right" [style]="{ width: '35%' }" draggable="false">
    <app-create-user *ngIf="editProfileVisible" [userData]="currentUserForEdit" (closeDialog)="onEditProfileClose()"></app-create-user>
  </p-dialog>

</header>